import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import modalSelector from '../selectors/modal'

import Box from 'grommet/components/Box'
import Heading from 'grommet/components/Heading'
import Layer from 'grommet/components/Layer'

import ContentDisplay from './ContentDisplay'
import Slider from './Slider'

import '../styles/Modal.css'

class Modal extends Component {
  _renderModalContent () {
    const {
      data
    } = this.props

    const {
      modalContentType,
      content
    } = data

    if (modalContentType === 'contentdisplay') {
      return (
        <ContentDisplay content={content.content} contentDisplayType={content.contentDisplayType} />
      )
    }

    if (modalContentType === 'slideshow') {
      return (
        <Slider slides={content.slides} />
      )
    }

    return null
  }

  render () {
    const {
      data,
      onClose
    } = this.props

    const {
      title
    } = data

    return (
      <Layer className='modal-layer' closer align='center' onClose={onClose} style={{overflow: 'hidden'}}>
        <Box align='center' colorIndex='primary-1' pad='small'>
          <Heading tag='h2'>{title}</Heading>
        </Box>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '1530px', height: '950px'}}>
          {this._renderModalContent()}
        </div>
      </Layer>
    )
  }
}

Modal.propTypes = {
  onClose: PropTypes.func,
  data: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
  const { modalId } = ownProps

  return {
    data: modalSelector(state, modalId)
  }
}

export default connect(mapStateToProps)(Modal)



// WEBPACK FOOTER //
// ./src/components/Modal.js